import Holidays from 'date-holidays'

const hd = new Holidays()
hd.init('US')

/**
 * @param date {string} Iso string format date
 * @returns holiday name IF it exists or false if it doesn't
 */
export const getHolidayName = (date: string): string | boolean => {
  const holiday = hd.isHoliday(date)

  if (holiday && holiday.length) {
    return holiday[0]?.name
  }

  return false
}

/**
 * @param dates {string[]} Iso string format dates
 * @returns holiday name IF it exists or false if it doesn't
 */
export const getFirstHolidayNameInArray = (dates: string[]): string | boolean => {
  let response: string | boolean = false

  for (const date of dates) {
    if (date) {
      response = getHolidayName(date)
      if (response) {
        break
      }
    }
  }

  return response
}
